import { css } from '@emotion/react';
import { useShallowCompareLayoutEffect } from '@core/hooks/useShallowCompareLayoutEffect';
import { AgoraComponent } from '@player/features/liveStream/components/AgoraComponent';
import { logError } from '@src/core/logging';
import { isAgora } from '../helpers';
import { VideoWrapperRenderer } from './VideoWrapperRenderer';
/**
 *
 */
export const VideoComponent = ({ videoWrapper, containerProps: { css: containerCss, ...containerProps } = {}, ...props }) => {
    useShallowCompareLayoutEffect(() => {
        // Rebind video props on video change
        if (videoWrapper) {
            Object.entries(props).forEach(([key, value]) => {
                if (typeof value !== 'undefined') {
                    if (key in videoWrapper) {
                        videoWrapper[key] = value;
                    }
                    else if (key.toLowerCase() in videoWrapper) {
                        videoWrapper[key.toLowerCase()] = value;
                    }
                    else {
                        logError(new Error(`"${key}" is not implemented on IVideoWrapper`));
                    }
                }
            });
        }
    }, [props, videoWrapper]);
    return (<div css={[
            css `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;

          video {
            width: 100%;
            height: 100%;
            outline-offset: -4px;
          }
        `,
            containerCss,
        ]} {...containerProps}>
      {isAgora(videoWrapper) ? (<AgoraComponent agoraWrapper={videoWrapper}/>) : (<VideoWrapperRenderer videoWrapper={videoWrapper}/>)}
    </div>);
};
